import { inject, Injectable, signal } from '@angular/core';
import { BaseHttpService } from './base.service';
import { catchError, tap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  permissions = signal<string>('');

  $baseHttpService = inject(BaseHttpService);

  getPermissions() {
    return this.$baseHttpService.get<string>('/permissions/get-all').pipe(
      tap((permissions) => this.permissions.set(permissions)),
      catchError(() => {
        return throwError(() => new Error('Error fetching permissions'));
      }),
    );
  }
}
